// const columns = [
//   {
//     title: "Staff",
//     dataIndex: "display_name",
//     key: "display_name",
//     scopedSlots: { customRender: "display_name" },
//     width: 250,
//   },
//   {
//     title: "Abnormal Date",
//     dataIndex: "ab_date",
//     key: "ab_date",
//     align: "center",
//     width: 120,
//   },
//   {
//     title: "Type",
//     dataIndex: "type",
//     key: "type",
//     width: 200,
//   },
//   {
//     title: "Check In / Check Out",
//     dataIndex: "check_in_out",
//     key: "check_in_out",
//     scopedSlots: { customRender: "check_in_out" },
//     align: "center",
//     width: 150,
//   },
//   {
//     title: "Absent Time (min)",
//     dataIndex: "minute_violation",
//     key: "minute_violation",
//     align: "right",
//     width: 150,
//   },
//   {
//     title: "Actual",
//     dataIndex: "actualType",
//     key: "actualType",
//     width: 200,
//   },
//   {
//     title: "Explanation hours",
//     dataIndex: "request.explanation_fund",
//     key: "explain_hours",
//     align: "right",
//     width: 150,
//   },
//   {
//     title: "Approver",
//     dataIndex: "approver_name",
//     key: "approver_name",
//     scopedSlots: { customRender: "approver_name" },
//     width: 250,
//   },
//   {
//     title: "Status",
//     dataIndex: "statusType",
//     key: "statusType",
//     scopedSlots: { customRender: "statusType" },
//     width: 120,
//   },
//   {
//     title: "Action",
//     dataIndex: "edit",
//     scopedSlots: { customRender: "edit" },
//     align: "center",
//     fixed: "right",
//     width: 80,
//   },
// ];
const columns = [
  {
    title: "Staff",
    dataIndex: "display_name",
    key: "display_name",
    scopedSlots: { customRender: "display_name" },
    width: 250,
  },
  {
    title: "Abnormal Date",
    dataIndex: "ab_date",
    key: "ab_date",
    align: "center",
    width: 120,
  },
  {
    title: "Work schedule",
    dataIndex: "work_schedule",
    key: "work_schedule",
    scopedSlots: { customRender: "work_schedule" },
    align: "center",
    width: 150,
  },
  {
    title: "Abnormal type",
    dataIndex: "reason_type",
    key: "reason_type",
    width: 150,
  },
  {
    title: "Check in",
    dataIndex: "check_in",
    scopedSlots: { customRender: "check_in_out" },
    key: "check_in",
    align: "center",
    width: 120,
  },
  {
    title: "Check out",
    dataIndex: "check_out",
    scopedSlots: { customRender: "check_in_out" },
    key: "check_out",
    align: "center",
    width: 120,
  },
  {
    title: "Absent time (min)",
    dataIndex: "minute_violation",
    key: "minute_violation",
    align: "center",
    width: 120,
  },
];

import AbnormalCaseDetail from "./AbnormalCaseDetail/AbnormalCaseDetail.vue";
import FilterLayout from "../../components/layouts/FilterLayout";
import { mapState } from "vuex";
import moment from "moment";
import http from "../../store/modules/helpers/httpInterceptor";
import {
  convertObjectToParams,
  formatDate,
  formatTime,
  scaleScreen,
  downloadFile,
  initFilters,
  getMessages,
  checkShowWithLastTimesheet,
  getInfoStaff,
  beforeUploadFile,
} from "../../components/commons/commons";
import {
  statusColor,
  statusText,
  statusName,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_FULL,
  FOLDER_NAME_ABNORMAL,
  FOLDER_NAME_LEAVE_REQUEST,
  TIME_STAFF,
  TIME_PM,
} from "../../components/commons/commonConstant";
import { Role, leavingType, DURATION_TYPES } from "../../components/commons/commonConstant";
export default {
  name: "Abnormal-case",
  components: { AbnormalCaseDetail, FilterLayout },
  data() {
    return {
      page: "Abnormal Case",
      currentScreen: "",
      columns,
      DURATION_TYPES,
      leavingType,
      currentPage: 1,
      pageSize: 10,
      field: "Name",
      visible: false,
      reasonReject: "",
      visibleModalRejectCancel: false,
      visibleUpdateAbnormal: false,
      sort: { direction: 1 },
      startValue: null,
      endValue: null,
      endOpen: false,
      actual: 1,
      statusPayload: {},
      total_items: 0,
      timeOut: null,
      source: {},
      form: this.$form.createForm(this, { name: "Explanation" }),
      formRejectCancel: this.$form.createForm(this, { name: "From Reject Cancel" }),
      formUpdateJob: this.$form.createForm(this, { name: "updateAbnormal" }),
      dataSource: [],
      filters: {},
      recordDetail: {},
      fetching: false,
      formData: {},
      statusColor: statusColor,
      Role,
      statusText,
      tempCheckDateInApprovedTimeSheet: [],
      firstCall: true,
      isEdit: false,
      clickButtonEdit: false,
      clickStatus: false,
      visibleDrawer: false,
      sizeReason: document.body.clientWidth / 6 + "px",
      tooltipOnsite: { config: { visible: false } },
      isDisableExport: true,
      size: window.outerWidth > 1000 ? window.outerWidth * 0.6 : window.outerWidth * 0.55,
      fileList: [],
      isVariableToDownLoad: false,
      request_type: FOLDER_NAME_ABNORMAL,
      download_id: "",
      isFlexible: false,
      moment: moment,
      isSystemCreate: true,
      requestHours: [],
      requestTypes: [
        {
          id: 1,
          code: "LEAVE_REQUEST",
          label: "Leave Request",
        },
        {
          id: 2,
          code: "EXPLANATION_REQUEST",
          label: "Explanation Request",
        },
      ],
      requestType: "",
      reasonType: "",
      isLoading: false,
      isExplanation: false,
      requestList: [],
      reasonList: [],
      remain_day: null,
      dateOfIssue: null,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 1 },
      },
      absentTime: 0,
      balances: 0,
      isDayIssueFlexible: false,
      isRejected: false,
    };
  },
  created() {
    this.currentScreen = this.roles.includes(Role.STAFF) ? "abnormal_case_staff" : "abnormal_case";
    this.scaleScreen();
    this.$store.dispatch("abnormalcase/getParamsDataToSelectActual");
    this.$store.dispatch("application/getReasonRequestList");
    this.getLastTimesheetInfo();
    window.addEventListener("resize", () => this.reportWindowSize());
    this.handFilters();
    this.firstCall = true;
  },
  computed: {
    ...mapState({
      reasonTypeList: (state) => state.application.reasonTypeList,
      userInfo: (state) => state.user.userInfo,
      abnormalList: (state) => state.abnormalcase.abnormalList.data,
      employeeList: (state) => state.application.employeeList,
      absentTypeList: (state) => state.application.absentTypesList,
      reasonRequestList: (state) => state.application.reasonRequestList,
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      dataActual: (state) => state.abnormalcase.dataActual,
      lastTimesheet: (state) => state.application.lastTimesheet,
      dataRequestSelections: (state) => state.request.dataRequestSelections,
      approverUser: (state) => state.application.approverUser,
      dataActualFixed: (state) => state.abnormalcase.dataActualFixed,
      loading: (state) => state.user.loading,
    }),
  },
  watch: {
    filters: function () {
      if (this.filters.fromDate !== undefined && this.filters.toDate !== undefined) {
        this.isDisableExport = false;
      } else {
        this.isDisableExport = true;
      }
    },
    visible(newValue) {
      if (newValue === false) {
        this.isSystemCreate = true;
        this.formData = {};
        this.form.resetFields();
        this.isEdit = false;
        this.isLoading = false;
        this.clickButtonEdit = false;
        this.clickStatus = false;
        this.absentTime = 0;
        this.balances = 0;
        this.isExplanation = false;
        this.request_type = FOLDER_NAME_ABNORMAL;
      }
    },
    visibleModalRejectCancel(newValue) {
      if (!newValue) {
        this.formRejectCancel.resetFields();
        this.isRejected = false;
      }
    },
    visibleDrawer(newValue) {
      if (newValue) {
        if (this.recordDetail?.request?.id) {
          this.getAllListFile(this.recordDetail.request.id);
        }
      }
    },
  },
  beforeMount() {
    this.isFlexible = this.userInfo.flexibleWorkSchedule;
  },
  methods: {
    formatTime,
    formatDate,
    scaleScreen,
    getMessages,
    getInfoStaff,
    onChangeDate(value) {
      this.getApprover(value.format(DATE_FORMAT_SHORT));
      this.getAbsentAndBalance(value.format(DATE_FORMAT_SHORT));
    },
    handFilters() {
      const { filters, currentScreen, userInfo } = this;
      initFilters(filters, currentScreen, userInfo);
      if (sessionStorage.getItem(this.page)) {
        this.filters = { ...JSON.parse(sessionStorage.getItem(this.page)) };
      } else {
        this.filters = {
          ...this.filters,
          ...JSON.parse(sessionStorage.getItem(this.page)),
        };
      }
    },
    getCheckInCheckOut(record) {
      const checkIn = this.formatTime(record.check_in);
      const checkOut = this.formatTime(record.check_out);
      if (checkIn && checkOut) {
        return `${checkIn} - ${checkOut}`;
      } else if (checkIn && !checkOut) {
        return `${checkIn} - --:--`;
      } else if (!checkIn && checkOut) {
        return `--:-- - ${checkOut}`;
      } else {
        return "-";
      }
    },
    getCheckInOrCheckOut(check) {
      const checkFormat = this.formatTime(check);
      return checkFormat ?? "";
    },
    getWorkSchedule(record) {
      const { start_time, end_time } = record;
      if (start_time && end_time) {
        return `${start_time} - ${end_time}`;
      } else if (start_time && !end_time) {
        return `${start_time} - --:--`;
      } else if (!start_time && end_time) {
        return `--:-- - ${end_time}`;
      } else {
        return "-";
      }
    },
    handleHover(event, description) {
      event.preventDefault();
      if (description) {
        this.tooltipOnsite.config = {
          visible: true,
          top: event.pageY + 10 + "px",
          left: event.pageX + 5 + "px",
        };
        this.tooltipOnsite.description = description;
      }
    },
    handleMouseLeave() {
      this.tooltipOnsite.config.visible = false;
    },
    reportWindowSize() {
      this.sizeReason = document.body.clientWidth / 6 + "px";
      if (document.body.clientWidth > 1000) {
        this.size = document.body.clientWidth * 0.6;
      } else {
        this.size = document.body.clientWidth * 0.55;
      }
    },
    checkEditVisible(record) {
      return (
        record.employee.user_name === this.userInfo.userName &&
        !record.is_expired &&
        checkShowWithLastTimesheet(record.abnormal_date, this.lastTimesheet.last_timesheet_period_end_date, TIME_STAFF)
      );
    },
    checkCancelVisible(record) {
      return (
        (record?.request?.isFlexible ?? false) &&
        record.employee.user_name === this.userInfo.userName &&
        !record.is_expired &&
        checkShowWithLastTimesheet(record.abnormal_date, this.lastTimesheet.last_timesheet_period_end_date, TIME_STAFF)
      );
    },
    checkEditChangeStatusVisible(record) {
      return (
        (record.assignee
          ? record.assignee.user_name === this.userInfo.userName
          : record.assignee && record.assignee.user_name === this.userInfo.userName) &&
        (record.status === 1 || record.status === 3) &&
        checkShowWithLastTimesheet(record.abnormal_date, this.lastTimesheet.last_timesheet_period_end_date, TIME_PM)
      );
    },
    checkMoreVisible(record) {
      return (
        (record.status === 1 || record.status === 3) &&
        (record.check_in || record.check_out) &&
        (this.checkEditChangeStatusVisible(record) || this.checkEditVisible(record))
      );
    },
    customRow(record) {
      return {
        on: {
          click: () => {
            this.isVariableToDownLoad = false;
            // this.fileList.splice(0, this.fileList.length);
            this.recordDetail = record;
            if (!this.clickButtonEdit) {
              if (!this.visible) {
                if (!this.clickStatus) {
                  this.visibleDrawer = true;
                }
                this.recordDetail = record;
              } else {
                this.visible = true;
              }
            } else {
              this.clickButtonEdit = false;
            }
          },
        },
      };
    },
    onSearchStaff(value, timeout) {
      let cloneVal = decodeURI(value);
      if (value && value !== "" && value.length >= 3) {
        this.fetching = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$store
            .dispatch("application/getEmployeeList", cloneVal)
            .then(() => {
              this.fetching = false;
            })
            .catch(() => {
              this.fetching = false;
            });
        }, timeout);
      }
    },
    onClose() {
      this.visibleDrawer = false;
    },

    handleRowClassName(record) {
      let query = this.$route.query;
      if (query && query.id && query.id === record.id) {
        return "active-row-abnormal-case";
      } else return "";
    },
    onClickMore(record) {
      this.clickButtonEdit = true;
      if (!this.roles.includes(Role.GUEST)) {
        let temp = "";
        this.isExplanation = true;
        if (record.request.mail) {
          record.request.mail.forEach((element) => {
            temp = temp + " " + element.user_name;
          });
        }
        this.$store.dispatch("request/getParamsDataToSelect", { screenType: "Abnormal" }).then((res) => {
          if (res?.data) {
            this.requestList = res.data.request_reason;
            this.onChangeRequest([record.request_type_code]);
          } else {
            this.requestList = [];
          }
        });
        this.dateOfIssue = moment(record.abnormal_date, DATE_FORMAT_FULL);
        this.formData = {
          request_type: this.requestTypes[1].code,
          request: record.request_type_code,
          staff: `${record.employee.name} - ${record.employee.department_name.nameEn}`,
          reason_request: record.reason_type_code,
          date: record.ab_date,
          description: record.request ? record.request.description : undefined,
          ccMail: record.request.mail_cc ? record.request.mail_cc : undefined,
          actual_type: record.request.leaving_type,
          explain_hour: record.request.explanation_fund,
        };
        this.onSearchStaff(temp);
      }
    },
    onSetDataFilters(filters) {
      this.filters = filters;
    },
    onClickEdit(record) {
      this.fileList.splice(0, this.fileList.length);
      this.getAllListFile(record?.request?.id ?? "");
      this.download_id = record.id;
      this.$store.dispatch("user/loadingRequest");
      this.source = record;
      this.isEdit = true;
      this.getApprover(this.dateOfIssue.format(DATE_FORMAT_SHORT));
      this.request_type = FOLDER_NAME_ABNORMAL;

      setTimeout(() => {
        this.visible = true;
        this.getAbsentAndBalance(this.dateOfIssue.format(DATE_FORMAT_SHORT));
        if (this.isFlexible) {
          this.$store
            .dispatch("application/getWorkScheduleUser", {
              userId: this.userInfo.userId,
              date: this.dateOfIssue.format(DATE_FORMAT_SHORT),
            })
            .then((res) => {
              this.isDayIssueFlexible = res;
              if (!res) {
                this.$store.dispatch("abnormalcase/getActualOfFixed");
              }
            });
        } else {
          this.$store.dispatch("abnormalcase/getActualOfFixed");
        }
        this.$store.dispatch("user/loadingRequest");
      }, 500);
    },

    showModal(record) {
      this.isExplanation = false;
      if (
        record.status === 0 &&
        !record.is_expired &&
        record.employee.user_name === this.userInfo.userName &&
        this.checkExplanable(record.abnormal_date)
      ) {
        this.request_type = FOLDER_NAME_LEAVE_REQUEST;
        this.clickStatus = true;
        this.isEdit = false;
        this.source = record;
        this.dateOfIssue = moment(record.abnormal_date, DATE_FORMAT_FULL);
        this.getApprover(this.dateOfIssue.format(DATE_FORMAT_SHORT));
        this.fileList.splice(0, this.fileList.length);
        this.$store.dispatch("request/getParamsDataToSelect", { screenType: "Abnormal" }).then((res) => {
          if (res?.data) {
            this.$store.dispatch("user/loadingRequest");
            this.requestList = res.data.request_reason;
            if (this.isFlexible) {
              this.onChangeRequest(["TIME_OFF"]);
            } else {
              this.onChangeRequest(["EXPLANATION", "ABSENCE"]);
            }
            setTimeout(() => {
              this.$store.dispatch("user/loadingRequest");
              this.visible = true;
            }, 500);
          } else {
            this.requestList = [];
          }
        });
        if (this.isFlexible) {
          this.formData = {
            request_type: this.requestTypes[0].code,
            request: "TIME_OFF",
            date: this.dateOfIssue,
          };
          this.$store
            .dispatch("application/getWorkScheduleUser", {
              userId: this.userInfo.userId,
              date: this.dateOfIssue.format(DATE_FORMAT_SHORT),
            })
            .then((res) => {
              this.isDayIssueFlexible = res;
            });
          this.$store
            .dispatch("application/getWorkScheduleUser", {
              userId: this.userInfo.userId,
              date: this.dateOfIssue.format(DATE_FORMAT_SHORT),
            })
            .then((res) => {
              const { code, data } = res;
              if (parseInt(code) === 200) {
                this.requestHours = [];
                if (data?.standard_working_time > 0) {
                  for (let i = 1; i <= data.standard_working_time; i++) {
                    this.requestHours.push({ label: `${i} hour(s)`, value: i });
                  }
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          this.isEdit = true;
          this.getAbsentAndBalance(this.dateOfIssue.format(DATE_FORMAT_SHORT));
          this.getInfoExplanation();
          // this.$store.dispatch("abnormalcase/getParamsDataToSelectActual");
          this.$store.dispatch("abnormalcase/getActualOfFixed");
        }
      }
    },
    onChangeRequestType(value) {
      this.form.resetFields();
      this.form.setFieldsValue({
        request_type: this.requestTypes[1].code,
      });
      if (this.requestTypes[1].code === value) {
        this.request_type = FOLDER_NAME_ABNORMAL;
        this.onChangeRequest(["EXPLANATION", "ABSENCE"]);
        this.getInfoExplanation();
        if (!this.isDayIssueFlexible) {
          this.$store.dispatch("abnormalcase/getActualOfFixed");
        }
      } else {
        this.request_type = FOLDER_NAME_LEAVE_REQUEST;
        this.formData = {
          request: "TIME_OFF",
          reason_request: undefined,
          date: this.dateOfIssue,
        };
        this.isExplanation = false;
        this.onChangeRequest(["TIME_OFF"]);
      }
    },
    getInfoExplanation() {
      this.isExplanation = true;
      this.formData = {
        request: "EXPLANATION",
        staff: this.userInfo.displayName,
        reason_request: this.source?.reason_type_code ?? "",
        date: this.dateOfIssue,
      };
      // this.$store
      // .dispatch("application/getAbsentData", {
      //   userId: this.userInfo.userId,
      //   date: this.dateOfIssue.format(DATE_FORMAT_SHORT),
      // })
      // .catch((err) => {
      //   this.$message.error(err.response.data.message);
      // });
      this.getAbsentAndBalance(this.dateOfIssue.format(DATE_FORMAT_SHORT));
    },
    onChangeRequest(values) {
      const findRequests = this.requestList.filter((item) => values.includes(item.request_type_code));
      if (findRequests && findRequests.length > 0) {
        const reasons = [];
        findRequests.forEach((item) => {
          reasons.push(...item.reasons);
        });
        this.reasonList = reasons;
      } else this.reasonList = [];
    },
    onChangeReasonRequest(value) {
      const findReason = this.reasonList.find((item) => item.reason_type_code === value);
      if (findReason) {
        const { dataRequestSelections } = this;
        this.form.setFieldsValue({ salary: findReason.salary });
        if (findReason.reason_type_code === "ANN_LEAVE_CORP") {
          this.remain_day = {
            day: dataRequestSelections.data.annual_leave_balance_days ?? 0,
            hours: dataRequestSelections.data.annual_leave_balance_hours ?? 0,
          };
        } else if (findReason.reason_type_code === "LOA_CORP_11") {
          this.remain_day = {
            day: dataRequestSelections.data.offset_day ?? 0,
          };
        } else if (findReason.reason_type_code === "BIRTHDAY_LEAVE") {
          this.remain_day = {
            day: dataRequestSelections.data.paid_birthday_leave ?? 0,
          };
        } else {
          this.remain_day = null;
        }
      }
    },
    createAbnormalCase() {
      const requestType = this.reasonTypeList.find((item) => item.request_type_code === "EXPLANATION");
      let reasonType;
      if (requestType) {
        reasonType = requestType.reasons?.find((item) => item?.reason_type_code === "NOT_ENOUGH_WORKING_HOURS");
      }
      this.requestType = requestType;
      this.reasonType = reasonType;
      this.visible = true;
      this.isSystemCreate = false;
      this.formData = {
        request: requestType ? requestType?.request_type : "Explanation Request",
        staff: this.userInfo.displayName,
        type: reasonType ? reasonType?.reason_type : "Not enough working hours",
        date: new Date(),
        explain_hour: undefined,
      };
      const dateCurrent = moment(new Date()).format(DATE_FORMAT_SHORT);
      this.getApprover(dateCurrent);
      this.getAbsentAndBalance(dateCurrent);
    },
    getAbnormalCaseData() {
      this.$store.dispatch("user/loadingRequest");
      const { pageSize, currentPage, sort, filters } = this;
      let param = {};
      if (this.firstCall) {
        param = {
          ...filters,
          ...sort,
        };
        this.currentPage = filters.page ? filters.page : 1;
        this.pageSize = filters.size ? filters.size : 10;
      } else {
        param = {
          ...filters,
          ...sort,
          page: currentPage,
          size: pageSize,
        };
      }
      const url = convertObjectToParams(param);
      this.$store
        .dispatch("abnormalcase/getAbnormalCaseData", url)
        .then((res) => {
          let data = [];

          if (res.data) {
            // res.data.forEach((element) => {
            //   this.checkDateInApprovedSchedule(element.abnormal_date);
            // });
            data = res.data.map((element, index) => {
              element.display_name = element.employee.name;
              element.department = this.getDepartment(element.employee);
              element.actualType = this.getActualType(this.dataActual, element);
              element.ab_date = formatDate(element.abnormal_date);
              element.approver_name = this.getInfoStaff(element?.assignee);
              element.assigner = this.getAssigner(element);
              element.statusText = statusText[element.status];
              element.type = element.reason_type ?? "";
              element.reason = element.description ?? "";
              element.dateInApprovedTimeSheet = this.tempCheckDateInApprovedTimeSheet[index];
              return element;
            });
            this.total_items = res.page.total_element;
            this.dataSource = data;
            this.tempCheckDateInApprovedTimeSheet = [];
            this.firstCall = false;
          } else if (res.message !== null && res.message !== "") {
            this.$message.error(res.message, 5);
          }
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
      sessionStorage.setItem(this.page, JSON.stringify(param));
    },
    getApproverName(element) {
      return element.assignee && element.assignee.name && element.assignee.department_name
        ? `${element.assignee.name} - ${element.assignee.department_name.nameEn}`
        : "Guest-manager";
    },
    getAssigner(element) {
      return element.assignee
        ? element.assignee.name && element.assignee.name !== null
          ? element.assignee.name + " - " + element.assignee.department_name.nameEn
          : "Guest-manager"
        : "No assignee";
    },

    getApprover(date) {
      this.$store.dispatch("application/getApproverUser", {
        userName: this.userInfo.userName,
        date,
      });
    },
    getAbsentAndBalance(date) {
      return http
        .get(`/tms/request-management/${this.userInfo.userId}/explanation-info/${date}`)
        .then((res) => {
          const data = res.data.data;
          this.absentTime = data?.absentTime ?? "-";
          this.balances = data?.balancesTime ?? "-";
        })
        .catch((err) => {
          this.$message.error(err.response.data?.message);
          throw err;
        });
    },
    getData(data) {
      return data ? data : "";
    },
    getActualType(dataActual, element) {
      let actualType = "";
      dataActual.forEach((type) => {
        if (element.request.leaving_type === type.code) {
          actualType = type.message;
        }
      });
      return actualType;
    },
    getDepartment(data) {
      let department = "";
      if (data.department_name) {
        department = data.department_name.name_en;
      } else {
        department = data.department;
      }
      return department;
    },

    // Form
    onChangeStartTime(value) {
      if (
        moment(moment(value).format("HH:mm:ss"), "HH:mm:ss").isAfter(
          moment(moment(this.form.getFieldValue("to")).format("HH:mm:ss"), "HH:mm:ss")
        )
      ) {
        this.form.setFieldsValue({ to: value });
      }
    },
    onChangeEndTime(value) {
      if (
        moment(moment(value).format("HH:mm:ss"), "HH:mm:ss").isBefore(
          moment(moment(this.form.getFieldValue("from")).format("HH:mm:ss"), "HH:mm:ss")
        )
      ) {
        this.form.setFieldsValue({ from: value });
      }
    },
    checkCreateUpdate(res) {
      if (parseInt(res.code) === 201 || parseInt(res.code) === 200) {
        getMessages(res.message).forEach((msg) => {
          this.$message.success(msg, 5);
        });
        this.visible = false;
        this.handleUpload(res.id);
        this.$store.dispatch("user/loadingRequest");
        this.getAbnormalCaseData();
        setTimeout(() => {
          this.$store.dispatch("user/loadingRequest");
        }, 500);
      } else {
        this.isLoading = false;
        getMessages(res.message).forEach((msg) => {
          this.$message.error(msg, 5);
        });
      }
    },
    handleSubmit(e) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        e.preventDefault();
        this.$emit("click");
        this.form.validateFields((err, values) => {
          if (!err) {
            this.isLoading = true;
            let payload = {
              request_type: values.request,
              reason_type: values.reason_request,
              mail_cc: values.ccMail ?? [],
              employee: this.userInfo.userId,
            };
            if (!this.isExplanation) {
              payload = {
                ...payload,
                description: values.description,
                request_dates: [
                  {
                    request_date: values.date.format(DATE_FORMAT_FULL),
                    request_hours: values?.hours,
                    duration: values?.duration,
                  },
                ],
              };
              this.$store
                .dispatch("request/createRequestFlexible", payload)
                .then((res) => {
                  this.checkCreateUpdate(res);
                })
                .catch((err) => {
                  this.checkCreateUpdate(err.response.data);
                });
            } else {
              payload = {
                ...payload,
                dateExplanation: values.date.format(DATE_FORMAT_FULL),
                description: values.description,
                leaving_type: values.actual_type ?? values.reason_request,
                explanation_fund: values.explain_hour,
              };
              this.$store
                .dispatch(
                  this.isEdit ? "abnormalcase/updateAbnormalCaseData" : "abnormalcase/createExplanationFlexible",
                  {
                    data: payload,
                    id: this.recordDetail.id,
                  }
                )
                .then((res) => {
                  this.checkCreateUpdate(res);
                })
                .catch((err) => {
                  this.checkCreateUpdate(err.response.data);
                });
            }
          }
        });
      }, 300);
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    checkUser(record) {
      if (record.employee.user_name === this.userInfo.userName) {
        return true;
      }
      return false;
    },
    handleCancel() {
      this.formData = {};
      this.form.resetFields();
      this.visible = false;
      this.isSystemCreate = true;
    },
    onApplyFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      this.getAbnormalCaseData();
    },
    onChangePage(page, size) {
      this.currentPage = page;
      this.pageSize = size;
      this.getAbnormalCaseData();
    },
    checkDateInApprovedSchedule(date) {
      let url = "?date=" + moment(date).format("YYYYMMDD");
      this.$store
        .dispatch("application/checkDateInApprovedPeriod", url)
        .then((res) => {
          if (res) {
            this.tempCheckDateInApprovedTimeSheet.push(res.data);
          }
        })
        .catch(() => {
          this.tempCheckDateInApprovedTimeSheet.push(true);
          this.$message.error("Failed to check date in approved timesheet!", 5);
        });
    },
    updateStatus(payload) {
      this.$store
        .dispatch("abnormalcase/updateStatusAbnormal", {
          data: payload.data,
          id: payload.id,
        })
        .then((res) => {
          if (res) {
            if (parseInt(res.code) === 200) {
              this.$message.success(res.message, 5);
            } else {
              this.$message.error(res.message, 5);
            }
            this.statusPayload = [];
            this.getAbnormalCaseData();
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data?.message, 5);
        });
    },
    onClickApproved(record, status) {
      this.statusPayload = {
        data: {
          status_type: statusName[status],
          reason: "",
          request_id: record.request ? record.request.id : this.message.error("No request created", 5),
        },
        id: record.id,
      };
      this.updateStatus(this.statusPayload);
    },
    checkExplanable(date) {
      if (new Date().getDate() < this.lastTimesheet.forbidden_request_date) {
        if (new Date(this.lastTimesheet.last_timesheet_period_end_date).getTime() >= new Date(date).getTime()) {
          return false;
        }
      } else if (new Date().getDate() === this.lastTimesheet.forbidden_request_date) {
        if (new Date().getHours() >= this.lastTimesheet.forbidden_request_time_in_hour) {
          if (new Date(this.lastTimesheet.last_timesheet_period_end_date).getTime() >= new Date(date).getTime()) {
            return false;
          }
        }
      }
      return true;
    },
    handleOk() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.formRejectCancel.validateFields((errors, values) => {
          if (!errors) {
            if (values.reason && values.reason.trim() !== "") {
              this.statusPayload.data.reason = values.reason;
              this.updateStatus(this.statusPayload);
              this.visibleModalRejectCancel = false;
            } else {
              this.$message.error("Reason is required!", 5);
            }
          }
        });
      }, 500);
    },
    onClickReject(record, status) {
      this.statusPayload = {
        data: {
          status_type: statusName[status],
          request_id: record.request ? record.request.id : this.$message.error("No request created", 5),
        },
        id: record.id,
      };
      this.visibleModalRejectCancel = true;
      this.isRejected = true;
    },
    onClickCancel(record, status) {
      this.statusPayload = {
        data: {
          status_type: statusName[status],
          request_id: record.request ? record.request.id : this.$message.error("No request created", 5),
        },
        id: record.id,
      };
      this.visibleModalRejectCancel = true;
      this.isRejected = false;
    },
    handleCancelRejectModel() {
      this.visibleModalRejectCancel = false;
    },
    onshowModalUpdate() {
      this.visibleUpdateAbnormal = true;
    },
    handleCancelModalUpdate() {
      this.formUpdateJob.resetFields();
      this.visibleUpdateAbnormal = false;
    },
    getLastTimesheetInfo() {
      this.$store
        .dispatch("application/getEndDateOfLastTimsheet")
        .then((res) => {
          if (!res) {
            this.$message.error(res.message, 5);
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data?.message, 5);
        });
    },
    handleSubmitJob(e) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        e.preventDefault();
        this.$emit("click");
        this.formUpdateJob.validateFields((err, values) => {
          if (!err) {
            let employee = [];
            let date = moment(values.date).format(DATE_FORMAT_SHORT);
            values.staff.forEach((element) => {
              employee.push(JSON.parse(element).value);
            });
            let payload = {
              employee,
              date,
            };
            this.$store
              .dispatch("abnormalcase/updateJobAbnormal", payload)
              .then((res) => {
                if (res) {
                  this.$message.success(res.message);
                  this.visibleUpdateAbnormal = false;
                  this.formUpdateJob.resetFields();
                }
              })
              .catch((error) => {
                this.$message.error(error.message, 5);
              });
          }
        });
      }, 2000);
    },
    beforeUpload(file) {
      const result = beforeUploadFile(file);
      if (result.isValid) {
        this.fileList = [...this.fileList, file];
      } else {
        this.$message.error(result.message, 5);
      }
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.deleteFile(this.source?.request?.id ?? "", file.name);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleUpload(id) {
      const { fileList } = this;
      const formData = new FormData();
      fileList.forEach((file) => {
        formData.append("file", file);
      });
      http
        .post(`/tms/request-management/${this.request_type}/${id}/upload?file`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.$message.success("Success");
          fileList.splice(0, fileList.length);
          return res.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    getAllListFile(id) {
      const { fileList } = this;
      fileList.splice(0, fileList.length);
      if (id) {
        http
          .get(`/tms/request-management/${this.request_type}/get-all-file-list?id=` + id)
          .then((res) => {
            if (res.data) {
              let tempData = res.data;
              tempData.forEach((record) => {
                fileList.push(record);
              });
              if (fileList.length > 0) {
                this.isVariableToDownLoad = true;
              } else {
                this.isVariableToDownLoad = false;
              }
              return tempData;
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    deleteFile(id, name) {
      http
        .get(`/tms/request-management/${this.request_type}/${id}/delete-file?name=` + name)
        .then((res) => {
          this.$message.success(res.data);
          if (this.fileList.length > 0) {
            this.isVariableToDownLoad = true;
          } else {
            this.isVariableToDownLoad = false;
          }
          return res.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    handleDownload() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        const { fileList } = this;
        fileList.forEach((file) => {
          http
            .get(`/tms/request-management/${this.request_type}/${this.download_id}/download?name=` + file.name, {
              responseType: "blob",
            })
            .then((res) => {
              downloadFile(res.data, file.name);
              return res.data;
            })
            .catch((err) => {
              throw err;
            });
        });
      }, 500);
    },
    exportRequest() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        const { filters, currentPage, pageSize } = this;
        this.currentPage = filters.page ? filters.page : 1;
        this.pageSize = filters.size ? filters.size : 10;
        const paramFilter = convertObjectToParams({
          ...filters,
          page: currentPage,
          size: pageSize,
        });
        this.$store.dispatch("user/loadingRequest");
        http
          .get(`tms/excel/abnormal-case${paramFilter}`, {
            responseType: "blob",
          })
          .then((res) => {
            if (res.status === 200 && res.data.type !== "application/json") {
              downloadFile(
                res.data,
                `AbnormalCase_List_${moment(filters.fromDate).format("DD/MM/yyyy")}-${moment(filters.toDate).format(
                  "DD/MM/yyyy"
                )}.xlsx`
              );
              this.$store.dispatch("user/loadingRequest", 5);
              this.$message.success("Request List is exported successfully!");
            } else {
              this.$store.dispatch("user/loadingRequest");
              this.$message.error("No data export", 5);
            }
          })
          .catch(async (error) => {
            this.$store.dispatch("user/loadingRequest");
            if (error.request.responseType === "blob" && error.response.data instanceof Blob) {
              const errorObject = JSON.parse(await error.response.data.text());
              this.$message.error(errorObject.message, 5);
            }
          });
      }, 500);
    },
    hideDrawer() {
      this.visibleDrawer = false;
    },
  },
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
};
